import type { ContentLocale } from "./types";

/** Formats a YYYY-MM-DD content date as a calendar date, independent of the viewer's timezone. */
export function formatContentDate(isoDate: string, locale: ContentLocale): string {
  return new Intl.DateTimeFormat(locale === "ro" ? "ro-RO" : "en-GB", {
    dateStyle: "long",
    timeZone: "UTC",
  }).format(new Date(`${isoDate}T00:00:00Z`));
}
